
import { ScheduleItem } from '@/integrations/supabase/client';
import { keynotes } from './sessions/keynotes';
import { breaks } from './sessions/breaks';
import { regularSessions } from './sessions/regular-sessions';
import { panels } from './sessions/panels';

// Add the new 9:00 AM keynote session
const keynote9AM: ScheduleItem = {
  id: "keynote-ma-capital-raising-trends",
  day: "day1",
  start_time: "09:00",
  end_time: "09:20",
  title: "Keynote I: M&A and Capital Raising Trends in AI infrastructure",
  description: null,
  location: "Main Hall",
  type: "Keynote",
  speaker: { name: "Nayur Khan, Partner - QuantumBlack, AI by McKinsey" },
  conference_id: null,
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString()
};

// Add the new morning keynote session
const morningKeynote: ScheduleItem = {
  id: "keynote-beyond-compliance-good-regulation",
  day: "day1",
  start_time: "09:20",
  end_time: "09:40",
  title: "Keynote II: Beyond Compliance: How Good Regulation Makes AI Better",
  description: null,
  location: "Main Hall",
  type: "Keynote",
  speaker: { name: "Philip Gaffney, CEO, Camgenium" },
  conference_id: null,
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString()
};

// Add the 9:40 AM keynote session
const keynote940AM: ScheduleItem = {
  id: "keynote-autonomous-ai-rulebook",
  day: "day1",
  start_time: "09:40",
  end_time: "10:00",
  title: "How Autonomous AI Will Rip Up The Rulebook",
  description: null,
  location: "Main Hall",
  type: "Keynote",
  speaker: { name: "Ramyani Basu, Senior Partner, Data & AI Practice, KEARNEY" },
  conference_id: null,
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString()
};

// Update the afternoon sessions with correct timings and details
const updatedAfternoonSessions: ScheduleItem[] = [
  {
    id: "talk-online-reputation-ai",
    day: "day1",
    start_time: "15:00",
    end_time: "15:15",
    title: "Generative Engine Optimization (Business Reputations in AI chatbots)",
    description: null,
    location: "Main Hall",
    type: "Talk",
    speaker: { name: "Speaker TBC" },
    conference_id: null,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: "talk-ai-global-regulatory",
    day: "day1",
    start_time: "15:15",
    end_time: "15:30",
    title: "AI Risk Management: Governance, Literacy & Compliance",
    description: null,
    location: "Main Hall",
    type: "Talk",
    speaker: { name: "Chris Eastham, Partner, FIELDFISHER" },
    conference_id: null,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: "talk-hungry-ai-data",
    day: "day1",
    start_time: "15:30",
    end_time: "15:45",
    title: "How to feed Hungry AI with high-quality Data, on Demand, at Scale",
    description: null,
    location: "Main Hall",
    type: "Talk",
    speaker: { name: "Kurt Kammerer, CEO, DataVaccinator" },
    conference_id: null,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: "talk-ai-forecasts-finance-crypto",
    day: "day1",
    start_time: "15:45",
    end_time: "16:00",
    title: "AI Forecasts in Finance & Crypto",
    description: null,
    location: "Main Hall",
    type: "Talk",
    speaker: { name: "Dr.Jeremy Sosabowski, CEO, AlgoDynamix" },
    conference_id: null,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  }
];

// Make sure we have all session types included and properly sorted by start time
export const day1Data: ScheduleItem[] = [
  keynote9AM,
  morningKeynote,
  keynote940AM,
  ...keynotes,
  ...breaks,
  ...regularSessions,
  ...panels,
  ...updatedAfternoonSessions
].sort((a, b) => {
  // Ensure proper sorting by time
  return a.start_time.localeCompare(b.start_time);
});
